import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import Form from 'react-bootstrap/Form';
import FormControl from 'react-bootstrap/FormControl';
import Button from 'react-bootstrap/Button';

import ThirdPartyAPI from '../../../api/ThirdPartyAPI';
import Const from '../../../util/Constants';
import withRouter from '../../../util/WithRouter';
import FieldController from '../../../controller/FieldController';
import ApiUiController from '../../../controller/ApiUiController';
import Util from '../../../util/Util';
import FieldAssigment from '../automation/FieldAssigment';
import AutomationAssigmnent from '../automation/AutomationAssigmnent';
import RegEx from '../../../util/RegEx';

class WebhookUpdate extends React.Component {

  constructor(props) {
    super(props);
    const id = parseInt(props.match.params.id);

    this.state = {
      inApiCall: id !== 0, id: id, name: '', method: Const.True, api_id: 0,
      module: Const.Lead, masterModule: undefined, inValid: {}
    };
    this.fields = [{}];
    this.assigments = [{}];
    this.basePath = this.props.match.path;
    this.models = reactLocalStorage.getObject(Const.Model);

    this.model = this.models.lead;
    this.modelFields = FieldController.getFilterFields(this.model.fields);

    this.masterFields = [{}];
    this.masterAssigments = [{}];
    this.masterModel = null;
    this.masterModelFields = null;

    this.users = this.models.user.options;
    this.basePath = this.props.match.path;
    this.basePath = this.basePath.substring(0, this.basePath.lastIndexOf('/add-edit'));
  }

  componentDidMount() {
    if (this.state.id !== 0) { ThirdPartyAPI.get(this.state.id, this.onReceived, this.onFail); }
  }
  onFail = (res) => {
    const message = res.message ? JSON.stringify(res.message) : 'Something went wrong';
    Util.showError(message);
    this.setState({ ...this.state, inApiCall: false });
  };

  onReceived = api => {
    this.fields = JSON.parse(api.fields);
    this.fields = this.fields.length !== 0 ? this.fields : [{}];

    this.assigments = JSON.parse(api.assigments);
    this.assigments = this.assigments.length !== 0 ? this.assigments : [{}];

    this.masterFields = api.master_fields ? JSON.parse(api.master_fields) : [{}];
    this.masterAssigments = api.master_assigments ? JSON.parse(api.master_assigments) : [{}];

    this.api_data = api.api_data ? JSON.parse(api.api_data) : null;

    const module = api.model_no;
    if (Const.Lead === module) {
      this.model = this.models.lead;
      this.modelFields = FieldController.getFilterFields(this.model.fields);
    } else if (Const.Contact === module) {
      this.model = this.models.contact;
      this.modelFields = FieldController.getFilterFields(this.model.fields);
    } else if (Const.Call === module) {
      this.model = this.models.call;
      this.modelFields = FieldController.getFilterFields(this.model.fields);
    } else if (Const.Meeting === module) {
      this.model = this.models.meeting;
      this.modelFields = FieldController.getFilterFields(this.model.fields);
    }

    const masterModule = api.master_model_no;
    if (Const.Lead === masterModule) {
      this.masterModel = this.models.lead;
      this.masterModelFields = FieldController.getFilterFields(this.masterModel.fields);
    } else if (Const.Contact === masterModule) {
      this.masterModel = this.models.contact;
      this.masterModelFields = FieldController.getFilterFields(this.masterModel.fields);
    } else if (Const.Call === masterModule) {
      this.masterModel = this.models.call;
      this.masterModelFields = FieldController.getFilterFields(this.masterModel.fields);
    } else if (Const.Meeting === masterModule) {
      this.masterModel = this.models.meeting;
      this.masterModelFields = FieldController.getFilterFields(this.masterModel.fields);
    }

    this.setState({
      ...this.state, inApiCall: false, id: api.id, module, masterModule,
      name: api.name, method: api.method, api_id: api.api_id
    });
  };

  nameChange = event => this.setState({ ...this.state, name: event.target.value });
  methodChange = tog => this.setState({ ...this.state, method: tog ? Const.True : Const.False });

  moduleChange = module => {
    if (!this.api_data) {
      this.api_data = {};
    }
    this.api_data['api_module'] = module;

    if (Const.Lead === module) {
      this.model = this.models.lead;
      this.modelFields = FieldController.getFilterFields(this.model.fields);
    } else if (Const.Contact === module) {
      this.model = this.models.contact;
      this.modelFields = FieldController.getFilterFields(this.model.fields);
    } else if (Const.Call === module) {
      this.model = this.models.call;
      this.modelFields = FieldController.getFilterFields(this.model.fields);
    } else if (Const.Meeting === module) {
      this.model = this.models.meeting;
      this.modelFields = FieldController.getFilterFields(this.model.fields);
    } else {
      return;
    }
    this.fields = [{}];
    this.setState({ ...this.state, module });
  };

  masterModuleChange = masterModule => {
    if (!this.api_data) {
      this.api_data = {};
    }
    this.api_data['api_module'] = masterModule;

    if (Const.Lead === masterModule) {
      this.masterModel = this.models.lead;
      this.masterModelFields = FieldController.getFilterFields(this.masterModel.fields);
    } else if (Const.Contact === masterModule) {
      this.masterModel = this.models.contact;
      this.masterModelFields = FieldController.getFilterFields(this.masterModel.fields);
    } else {
      this.masterModel = null;
      this.masterModelFields = null;
    }

    this.setState({ ...this.state, masterModule });
  };

  onSave = () => {
    let inValid = {};
    if (this.state.name.trim() === '') inValid = { ...inValid, name: 'Invalid Field' };
    if (this.fields.length === 0) inValid = { ...inValid, fields: 'Invalid Field' };

    if (Object.keys(inValid).length === 0) {
      this.setState({ ...this.state, inApiCall: true });
      const api = {
        id: this.state.id,
        name: this.state.name,
        method: this.state.method,
        model_no: this.state.module,
        fields: JSON.stringify(this.fields),
        assigments: JSON.stringify(this.assigments),

        master_model_no: this.state.masterModule ? this.state.masterModule : 0,
        master_fields: this.state.masterModule ? JSON.stringify(this.masterFields) : '',
        master_assigments: this.state.masterModule ? JSON.stringify(this.masterAssigments) : '',

        api_id: this.state.api_id,
        type: 1,
        party_type: 1
      };
      ThirdPartyAPI.save(api, this.onSaved, this.onFail);
    } else {
      Util.showNotification('Form incomplete', 'Please fill all information', 'danger');
      this.setState({ ...this.state, inValid: { ...inValid } });
    }
  };
  onSaved = () => {
    Util.showNotification('Successful', 'Successfully saved.', 'success');
    this.props.navigate(this.basePath);
  };

  addField = () => { this.fields.push({}); this.setState({ ...this.state, inValid: {} }); };
  editField = (index, field) => this.fields[index] = field;
  deleteField = index => {
    this.fields = this.fields.filter((_, i) => i !== index);
    this.setState({ ...this.state, inValid: {} });
  };

  addMasterField = () => {
    this.masterFields.push({});
    this.setState({ ...this.state, inValid: {} });
  };
  editMasterField = (index, field) => this.masterFields[index] = field;
  deleteMasterField = index => {
    this.masterFields = this.masterFields.filter((_, i) => i !== index);
    this.setState({ ...this.state, inValid: {} });
  };

  addAssign = () => { this.assigments.push({}); this.setState({ ...this.state, inValid: {} }); };
  editAssign = (index, assigment) => this.assigments[index] = assigment;
  deleteAssign = index => {
    this.assigments = this.assigments.filter((_, i) => i !== index);
    this.setState({ ...this.state, inValid: {} });
  };

  addMasterAssign = () => {
    this.masterAssigments.push({});
    this.setState({ ...this.state, inValid: {} });
  };
  editMasterAssign = (index, assigment) => this.masterAssigments[index] = assigment;
  deleteMasterAssign = index => {
    this.masterAssigments = this.masterAssigments.filter((_, i) => i !== index);
    this.setState({ ...this.state, inValid: {} });
  };

  render() {
    const inValid = this.state.inValid;

    return (
      <div className="sectionform pt-4 ">
        <div className="container form-cont">
          <div className="row">
            <div className="col-md-12 pb-4"><h3>API</h3></div>
          </div>

          <ApiUiController inApiCall={this.props.inApiCall}>
            <Form className="row row-cols-3 lead-form">
              <div className="col-md-4">
                <div className="form-group">
                  <FormControl type='text' placeholder='Name'
                    className={`mr-sm-2 ${RegEx.class(inValid, 'name')}`}
                    value={this.state.name} onChange={this.nameChange} />
                </div>
              </div>

              <div className="col-md-4 condition-formcheck-div">
                <p>Conditional Option</p> &nbsp;
                <div className="condition-formcheck">
                  <Form.Check type="radio">
                    <Form.Check.Input type="radio" checked={this.state.method === Const.True}
                      onChange={() => this.methodChange(true)} />
                    <Form.Check.Label>POST</Form.Check.Label>
                  </Form.Check>
                  <Form.Check type="radio" className="formcheck2">
                    <Form.Check.Input type="radio" checked={this.state.method === Const.False}
                      onChange={() => this.methodChange(false)} />
                    <Form.Check.Label>GET</Form.Check.Label>
                  </Form.Check>
                </div>
              </div>

              <div className="formhead col-md-12"><h4>Module</h4></div>
              <div className="col-md-12 condition-formcheck-div">
                <div className="condition-formcheck">
                  <Form.Check type="radio" className="formcheck2">
                    <Form.Check.Input type="radio" checked={this.state.module === Const.Lead}
                      onChange={() => this.moduleChange(Const.Lead)} />
                    <Form.Check.Label>{this.models.lead.model_name}</Form.Check.Label>
                  </Form.Check>
                  <Form.Check type="radio" className="formcheck2">
                    <Form.Check.Input type="radio" checked={this.state.module === Const.Contact}
                      onChange={() => this.moduleChange(Const.Contact)} />
                    <Form.Check.Label>{this.models.contact.model_name}</Form.Check.Label>
                  </Form.Check>
                  <Form.Check type="radio" className="formcheck2">
                    <Form.Check.Input type="radio" checked={this.state.module === Const.Call}
                      onChange={() => this.moduleChange(Const.Call)} />
                    <Form.Check.Label>{this.models.call.model_name}</Form.Check.Label>
                  </Form.Check>
                  <Form.Check type="radio" className="formcheck2">
                    <Form.Check.Input type="radio" checked={this.state.module === Const.Meeting}
                      onChange={() => this.moduleChange(Const.Meeting)} />
                    <Form.Check.Label>{this.models.meeting.model_name}</Form.Check.Label>
                  </Form.Check>
                </div>
              </div>

              <div className="formhead col-md-12"><h4>Fields</h4></div>
              <FieldAssigment module={this.state.module} fields={this.modelFields} value={this.fields}
                onAdd={this.addField} onEdit={this.editField} onDelete={this.deleteField}
                zones={this.zones} dZone={this.dZone} onFormat={this.formatAssign} api_data={this.api_data} />

              <div className="formhead col-md-12"><h4>Master Module (if any)</h4></div>
              <div className="col-md-12 condition-formcheck-div">
                <div className="condition-formcheck">
                  <Form.Check type="radio" className="formcheck2">
                    <Form.Check.Input type="radio" checked={!this.state.masterModule}
                      onChange={() => this.masterModuleChange(undefined)} />
                    <Form.Check.Label>None</Form.Check.Label>
                  </Form.Check>
                  <Form.Check type="radio" className="formcheck2">
                    <Form.Check.Input type="radio" checked={this.state.masterModule === Const.Lead}
                      onChange={() => this.masterModuleChange(Const.Lead)} />
                    <Form.Check.Label>{this.models.lead.model_name}</Form.Check.Label>
                  </Form.Check>
                </div>
              </div>
              {this.masterModel ?
                <>
                  <div className="formhead col-md-12"><h4>Master Fields</h4></div>
                  <FieldAssigment
                    module={this.state.masterModule} fields={this.masterModelFields} value={this.masterFields}
                    onAdd={this.addMasterField} onEdit={this.editMasterField} onDelete={this.deleteMasterField}
                    zones={this.zones} dZone={this.dZone} onFormat={this.formatAssign} api_data={this.api_data} />
                </>
                : null
              }

              <div className="formhead col-md-12"><h4>Field Assigments</h4></div>
              <AutomationAssigmnent fields={this.modelFields} module={this.state.module} assigments={this.assigments}
                model={this.model} onAdd={this.addAssign} onEdit={this.editAssign} onDelete={this.deleteAssign} />

              {this.masterModel ?
                <>
                  <div className="formhead col-md-12"><h4>Master Field Assigments</h4></div>
                  <AutomationAssigmnent fields={this.masterModelFields} module={this.state.masterModule}
                    assigments={this.masterAssigments} model={this.masterModel}
                    onAdd={this.addMasterAssign} onEdit={this.editMasterAssign} onDelete={this.deleteMasterAssign} />
                </>
                : null
              }

              <div className="col-md-12 text-center btnsend">
                <Button variant="success" onClick={this.onSave}>Save</Button>
              </div>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}
export default withRouter(WebhookUpdate);